export default {
    "Choose a plan": "Choisissez un plan",
    "General Conditions of Use": "Conditions Générales d'Utilisation",
    "Current plan": "Plan actuel",
    "Expired of plan :": "Plan expiré :",
    "Contact sales": "Contacter un commercial",
    // PlanTunnelThankYou.vue
    "Thank you for the": "Merci pour le",
    "BUY_FOR_FREE": "ACHETER GRATUITEMENT",
    "purchase": "achat",
    "Home": "Accueil",
    // PlanTunnelProceed.vue
    "Proceed to payment": "Procéder au paiement",
    "Back": "Retour",
    "This plan is no longer available.": "Ce plan n'est plus disponible.",
    "Please select a different plan.": "Veuillez sélectionner un plan différent.",
    "This plan may have been purchased in another window, or your plan expired during the payment process":
        "Ce plan a peut-être été acheté dans une autre fenêtre, ou il a expiré pendant le processus de paiement.",
    "Buy for free": "Acheter gratuitement",
    // PlanTunnelPlan.vue
    "Expired": "Expiré",
    "End of plan :": "Fin du plan :",
    "Cancel": "Annuler",
    "Cancel renew": "Annuler le renouvellement",
    "Your current plan will expire on": "Votre plan actuel expirera le",
    "By clicking “CONFIRM”, you will still benefit of all features until this date.":
        "En cliquant sur « CONFIRMER », vous bénéficierez de toutes les fonctionnalités jusqu'à cette date.",
    "Confirm": "Confirmer",
    "All content deleted on :": "Tout le contenu sera supprimé le :",
    "Upgrade": "Changer d'offre",
    "Extend": "Prolonger",
    "Renew": "Renouveler",
    "Register": "S'inscrire",
    "Additional hour": "Heure supplémentaire",
    // PlanTunnelHoursTooltip.vue
    "Additional hours can be bought at any time. They can be used for the entire duration of the plan":
        "Des heures supplémentaires peuvent être achetées à tout moment. Elles peuvent être utilisées pendant toute la durée du plan",

    // Nouvelles clés pour $vt()
    "Hour": "Heure",
    "hours": "heures",
    "hour": "heure",
    "min": "min",
    "0 minutes": "0 minute",
    "Available hours": "Heures disponibles",
    "You can stream up to": "Vous pouvez diffuser jusqu'à",
    "You have spent all your available hours": "Vous avez utilisé toutes vos heures disponibles",
    "Buy extra hours": "Acheter des heures",
    "History": "Historique",
    "Up to": "Jusqu'à",
    "viewers": "spectateurs",
    "Replay avalable for": "Rediffusion disponible pendant",
    "Expire": "Expire",

    // Nouvelles clés pour $vtc()
    "hour|hours": "heure|heures",
    "minute|minutes": "minute|minutes",
    "viewer|viewers": "spectateur|spectateurs",

    // Traduction corrigée pour "Replay available for"
    "Replay available for": "Rediffusion disponible pendant",
    // Conserver également l'ancienne clé pour compatibilité éventuelle
    "Replay avalable for": "Rediffusion disponible pendant",
}